import React from 'react';

const HomeIcon: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Roof */}
    <path
      d="M2.5 8L9 2.5L15.5 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* House body */}
    <path
      d="M4 7V14.5C4 14.8 4.2 15 4.5 15H7.5V11.5C7.5 11.2 7.7 11 8 11H10C10.3 11 10.5 11.2 10.5 11.5V15H13.5C13.8 15 14 14.8 14 14.5V7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HomeIcon;
